import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\RemoveItemDossierFromSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/RemoveItemDossierFromSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/remove-item-dossiers'
*/
const RemoveItemDossierFromSupplierOrderController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveItemDossierFromSupplierOrderController.url(args, options),
    method: 'delete',
})

RemoveItemDossierFromSupplierOrderController.definition = {
    methods: ["delete"],
    url: '/api/supplier-order/{supplier_order}/remove-item-dossiers',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\SupplierOrder\RemoveItemDossierFromSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/RemoveItemDossierFromSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/remove-item-dossiers'
*/
RemoveItemDossierFromSupplierOrderController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return RemoveItemDossierFromSupplierOrderController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\RemoveItemDossierFromSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/RemoveItemDossierFromSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/remove-item-dossiers'
*/
RemoveItemDossierFromSupplierOrderController.delete = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveItemDossierFromSupplierOrderController.url(args, options),
    method: 'delete',
})

export default RemoveItemDossierFromSupplierOrderController